module.exports = "/_next/static/images/food-2955e0a7cffb2ee814486fa06b61a46b.png";